//common
export const onRestaurantLoad = (restaurant_id) => ({type: 'restaurant/load', restaurant_id })
export const onRestaurantLoadSuccess = (response) => ({type: 'restaurant/load/success', response })
export const onRestaurantLoadFail = (e) => ({type: 'restaurant/load/fail', e })

export const onRestaurantSave = (restaurant_id, params) => ({type: 'restaurant/save', restaurant_id, params })
export const onRestaurantSaveSuccess = (response) => ({type: 'restaurant/save/success', response })
export const onRestaurantSaveFail = (e) => ({type: 'restaurant/save/fail', e })

export const onRestaurantTimesSave = (restaurant_id, params) => ({type: 'restaurant/times/save', restaurant_id, params })
export const onRestaurantTimesSaveSuccess = (response) => ({type: 'restaurant/times/save/success', response })
export const onRestaurantTimesSaveFail = (e) => ({type: 'restaurant/times/save/fail', e })

//integrations
export const onPosIntegrationsLoad = (restaurant_id) => ({type: 'POS_INTEGRATIONS_LOAD', restaurant_id })
export const onPosIntegrationsLoadSuccess = (response) => ({type: 'POS_INTEGRATIONS_LOAD_SUCCESS', response })
export const onPosIntegrationsLoadFail = (e) => ({type: 'POS_INTEGRATIONS_LOAD_FAIL', e })

export const onPosIntegrationsSave = (data, invalidateStore) => ({type: 'POS_INTEGRATIONS_SAVE', data, invalidateStore })
export const onPosIntegrationsSaveSuccess = (response) => ({type: 'POS_INTEGRATIONS_SAVE_SUCCESS', response })
export const onPosIntegrationsSaveFail = (e) => ({type: 'POS_INTEGRATIONS_SAVE_FAIL', e })

export const onIikoTransportUpdateSelectedField = (field, value) => ({type: 'iikoTransport/selected/update_field', field, value })

//organizations
export const onIikoTransportOrganizationsShowModal = (bool) => ({type: 'iikoTransport/organizations/show_modal', bool })

export const onIikoTransportOrganizationsLoad = (restaurant_id, api_login) => ({type: 'iikoTransport/organizations/load', restaurant_id, api_login })
export const onIikoTransportOrganizationsLoadSuccess = (response) => ({type: 'iikoTransport/organizations/load/success', response })
export const onIikoTransportOrganizationsLoadFail = (e) => ({type: 'iikoTransport/organizations/fail', e })

export const onIikoTransportSetOrganization = (params) => ({type: 'IIKO_TRANSPORT_SET_ORGANIZATION', params })
export const onIikoTransportSetOrganizationSuccess = (response) => ({type: 'IIKO_TRANSPORT_SET_ORGANIZATION_SUCCESS', response })
export const onIikoTransportSetOrganizationFail = (e) => ({type: 'IIKO_TRANSPORT_SET_ORGANIZATION_FAIL', e })

//terminals
export const onIikoTransportTerminalsShowModal = (bool) => ({type: 'iikoTransport/terminals/show_modal', bool })

export const onIikoTransportTerminalsLoad = (restaurant_id, integration_id) => ({type: 'iikoTransport/terminals/load', integration_id, restaurant_id })
export const onIikoTransportTerminalsLoadSuccess = (response) => ({type: 'iikoTransport/terminals/load/success', response })
export const onIikoTransportTerminalsLoadFail = (e) => ({type: 'iikoTransport/terminals/fail', e })

export const onIikoTransportSetTerminal = (params) => ({type: 'iikoTransport/terminal/set', params })
export const onIikoTransportSetTerminalSuccess = (response) => ({type: 'iikoTransport/terminal/load/success', response })
export const onIikoTransportSetTerminalFail = (e) => ({type: 'iikoTransport/terminal/fail', e })

//payments
export const onIikoTransportPaymentsShowModal = (bool) => ({type: 'iikoTransport/payments/show_modal', bool })

export const onIikoTransportPaymentsLoad = (restaurant_id, integration_id) => ({type: 'iikoTransport/payments/load', integration_id, restaurant_id })
export const onIikoTransportPaymentsLoadSuccess = (response) => ({type: 'iikoTransport/payments/success', response })
export const onIikoTransportPaymentsLoadFail = (e) => ({type: 'iikoTransport/payments/fail', e })

export const onIikoTransportSetPayment = (params) => ({type: 'iikoTransport/payment/set', params })
export const onIikoTransportSetPaymentSuccess = (response) => ({type: 'iikoTransport/payment/success', response })
export const onIikoTransportSetPaymentFail = (e) => ({type: 'iikoTransport/payment/fail', e })

//tables
export const onIikoTransportImportTables = (restaurant_id, integration_id) => ({type: 'iikoTransport/tables/import', restaurant_id, integration_id })
export const onIikoTransportImportTablesSuccess = (response) => ({type: 'iikoTransport/tables/import/success', response })
export const onIikoTransportImportTablesFail = (e) => ({type: 'iikoTransport/tables/import/fail', e })

export const onTablesLoad = (restaurant_id, page) => ({type: 'iikoTransport/tables/load', restaurant_id, page })
export const onTablesLoadSuccess = (response) => ({type: 'iikoTransport/tables/load/success', response })
export const onTablesLoadFail = (e) => ({type: 'iikoTransport/tables/load/fail', e })

//discounts
export const onIikoTransportImportDiscounts = (restaurant_id, integration_id) => ({
    type: 'iikoTransport/discounts/import', restaurant_id, integration_id })
export const onIikoTransportImportDiscountsSuccess = (response) => ({type: 'iikoTransport/discounts/import/success', response })
export const onIikoTransportImportDiscountsFail = (e) => ({type: 'iikoTransport/discounts/import/fail', e })

export const onDiscountsLoad = (restaurant_id, page) => ({type: 'iikoTransport/discounts/load', restaurant_id, page })
export const onDiscountsLoadSuccess = (response) => ({type: 'iikoTransport/discounts/load/success', response })
export const onDiscountsLoadFail = (e) => ({type: 'iikoTransport/discounts/load/fail', e })

export const onSelectServiceChargeId = (restaurant_id, integration_id, service_charge_id, invalidateStore) => ({
    type: 'iikoTransport/service-charge/select', restaurant_id, integration_id, service_charge_id, invalidateStore })
export const onSelectServiceChargeIdSuccess = (response) => ({type: 'iikoTransport/service-charge/select/success', response })
export const onSelectServiceChargeIdFail = (e) => ({type: 'iikoTransport/service-charge/select/fail', e })

//servers
export const onIikoTransportSetServer = (value) => ({type: 'IIKO_TRANSPORT_SET_SERVER', value })

//payments
export const onIikoTransportExternalMenuShowModal = (bool) => ({type: 'iikoTransport/external_menu/show_modal', bool })

export const onIikoTransportExternalMenuLoad = (restaurant_id, integration_id) => ({type: 'iikoTransport/external_menu/load', integration_id, restaurant_id })
export const onIikoTransportExternalMenuLoadSuccess = (response) => ({type: 'iikoTransport/external_menu/success', response })
export const onIikoTransportExternalMenuLoadFail = (e) => ({type: 'iikoTransport/external_menu/fail', e })

export const onIikoTransportSetExternalMenu = (params) => ({type: 'iikoTransport/set_external_menu/set', params })
export const onIikoTransportSetExternalMenuSuccess = (response) => ({type: 'iikoTransport/set_external_menu/success', response })
export const onIikoTransportSetExternalMenuFail = (e) => ({type: 'iikoTransport/set_external_menu/fail', e })
